import React, {useContext, useMemo, useState,} from 'react'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {BsArrowLeftCircle, BsDisplayFill, BsEye, BsEyeSlashFill, BsGearFill, BsTrash} from "react-icons/bs";
import {TabNavigation} from '../../../Shared/components/TabNavigation'
import useTranslate from "../../../../modules/local/useTranslate";
import {getId, getType} from "../../../../apis/model/base";
import {Avatar, Button} from "antd";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {useRouterSearchParam} from "../../../../modules/navigation/useOnLocationChange";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import classNames from "classnames";
import {showDeleteConfirmDialog} from "../../../AppLocals/factory/createConfirmDialog";
import {AiFillDelete} from "react-icons/ai";
import {ShopContainerContext} from "./ShopContainer";
import ShopProducts from "./ShopProducts";
import {ShopFormEdit} from "../../../AppLocals/Shop/components/ShopForm";
import {useShopForm} from "../../../AppLocals/Shop/functions/useShopForm";
import WorkspaceContext from "../../WorkspaceContext";
import _ from "lodash"
import {PiNotePencilBold, PiPlusCircleBold} from "react-icons/pi";
import {useProductCatalogForm} from "../../../AppLocals/Shop/functions/useProductCatalogForm";
import CRUD from "../../../Shared/enums/CRUD";
import {useSelectEntities} from "../../../../redux/entities/useSelectEntities";
import {shopSchema} from "../../../../apis";
import {FaBoxOpen} from "react-icons/fa6";
import {RiListCheck2} from "react-icons/ri";
import {formatNumber} from "../../../../helpers/number";
import {IoStorefront} from "react-icons/io5";
import {convertFromString} from "../../../SlateEditor/functions";
import {SlateRenderer} from "../../../SlateEditor";
import {isRawContentEmpty} from "../../../SlateEditor/functions/parseRawContent";
import {GoDotFill} from "react-icons/go";
import EmptyHolder from "../../../../components/EmptyHolder";

// --- Cấu trúc Menu Cấp 2 (Chi tiết Khóa học) ---
const TABS_CONFIG = [
    {key: 'overview', name: 'overview', icon: <BsDisplayFill size={18}/>},
    {key: 'products', name: 'products', icon: <FaBoxOpen size={18}/>},
    {key: 'catalogs', name: 'catalogs', icon: <RiListCheck2 size={18}/>},
    {key: 'settings', name: 'shop settings', icon: <BsGearFill size={16}/>},
    {key: 'destroy', name: 'delete content', icon: <AiFillDelete size={16}/>},
];




const ShopCatalogs = ({shop: __shop}) => {
    const t = useTranslate()
    const shop = useSelectEntities(getId(__shop), shopSchema, __shop)

    const {
        modal,
        onCancel,
        handleAction,

        confirmDelete,
        refreshKey,

        createNewCatalog,
        updateCatalogInfo,
        deleteCatalog
    } = useProductCatalogForm({shop})

    const renderItem = ({className = ""}) => (eItem, eIndex) => {
        return (
            <div key={eIndex} className={classNames("flex flex-col gap-3", className)}>
                <div className="flex items-center flex-1">
                    <div className="flex-1">
                        {eItem?.title}
                    </div>
                    <div className="pr-1 flex gap-1 whitespace-pre-line">
                        <Button
                            size="small"
                            icon={eItem?.invisible ? <BsEyeSlashFill size={14}/> : <BsEye size={14} />}
                            onClick={(e) => {
                                e.stopPropagation();
                                updateCatalogInfo({invisible: !eItem?.invisible ? 1 : 0}, {id: eItem?.id});
                            }}
                            className={classNames(
                                "flex flex-center background-200 hover:bg-indigo-50 no-border",
                                eItem?.invisible ? 'text-indigo-600' : 'text-color-300',
                            )}
                        />
                        <Button
                            size="small"
                            icon={<PiPlusCircleBold size={14}/>}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleAction(CRUD.CREATE);
                            }}
                            className="flex flex-center bg-green-50 hover:bg-primary-100 text-green-700 no-border"
                        />
                        <Button
                            size="small"
                            icon={<PiNotePencilBold size={16}/>}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleAction(CRUD.UPDATE, eItem);
                            }}
                            className="flex flex-center bg-blue-50 hover:bg-blue-50 text-blue-600 no-border"
                        />
                        <Button
                            size="small"
                            icon={<BsTrash size={14} />}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleAction(CRUD.DELETE, eItem);
                            }}
                            className="flex flex-center text-primary-600 no-border"
                        />
                    </div>
                </div>
                {eItem?.children?.length > 0 && (
                    <div className="ml-4 flex flex-col gap-1">
                        {_.get(eItem, 'children', []).map((e, i) => (
                            <div className="pl-1 py-1 flex items-center flex-1 gap-3 hover:shadow hover:background-50 rounded-md cursor-pointer">
                                <GoDotFill size={10} className="text-color-400"/>
                                {renderItem({className: "flex-1 font-semibold text-sm text-color-100 tracking-wider"})(e, i)}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        )
    }

    return (
        <div className="bg-white flex flex-col gap-6">
            <div className={classNames("flex flex-col gap-3")}>
                <div className="flex items-center justify-between p-1 border-b border-dashed border-gray-300">
                    <div className="font-semibold text-gray-700">
                        Root
                    </div>
                    <Button
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            handleAction(CRUD.CREATE);
                        }}
                        color="primary" variant="solid"
                        className="flex flex-center font-medium text-xs">
                        {t('add new')}
                    </Button>
                </div>
            </div>
            {shop?.product_catalogs?.length > 0 ? (
                _.get(shop, 'product_catalogs', []).map(renderItem({className: 'font-bold text-base text-indigo-600 tracking-wide'}))
            ) : (
                <EmptyHolder description="no data is available now" className="py-12" />
            )}
            {modal}
        </div>
    )
}

const ShopDetail = ({shop}) => {
    const t = useTranslate();
    const shopDetailTab = useRouteSearchParam("shop-detail-tab") || "overview"
    const [activeTab, setActiveTab] = useState(shopDetailTab);

    const {isSm, isLg} = useContext(LayoutContext)
    const {
        current_shop_id, setCurrentShopId,
        current_product_id, setCurrentProductId,
        onSelectShopContainerRoute
    } = useContext(ShopContainerContext);
    const {organization} = useContext(WorkspaceContext);

    const {onChangeSearchParams} = useRouterSearchParam({})

    const {
        modal: shopModal,
        handleAction: handleShopAction,
        onCancel: onShopCancel,
        refreshKey: refreshShopKey,
        createNewShop,
        editShopInfo,
        deleteShop
    } = useShopForm({organization})

    const {description, about} = shop ?? {}

    // Render nội dung cụ thể cho từng tab Cấp 2
    const renderTabContent = useMemo(() => {
            switch (activeTab) {
                case 'overview':
                    return (
                        <div className="flex flex-col gap-6">
                            <div className="flex flex-col gap-2">
                                <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                    {t('shop information')}
                                </h3>
                                {description ? (
                                    <div className="text-color-300 tracking-wider">
                                        {description}
                                    </div>
                                ) : (
                                    <div className="p-6 flex flex-col items-center gap-3">
                                        <IoStorefront size={40} style={{color: '#dedede'}}/>
                                        <span className="text-center font-medium text-sm text-color-100 tracking-wide">
                                            {t("please write a few lines to introduce your store")}
                                        </span>
                                        <span className="text-center text-sm text-color-300 tracking-wider italic">
                                            {t('no data is available now')}
                                        </span>
                                    </div>
                                )}
                                {!isRawContentEmpty(about) ? (
                                    <div style={{fontSize: 13}}>
                                        <SlateRenderer value={convertFromString(about)} />
                                    </div>

                                ) : null}
                            </div>
                            <div className="flex flex-col gap-2">
                                <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                    {t('insights')}
                                </h3>
                                <div className="ml-2 grid grid-cols-1 md:grid-cols-3 gap-4">
                                    <div
                                        style={{
                                            border: '1px solid rgba(253, 186, 116, 1)',
                                            boxShadow: '0 2px 4px 0px rgba(254, 215, 170, 1)',
                                        }}
                                        className="px-4 py-3 flex items-center justify-between border border-color-100 background shadow-md rounded-xl">
                                        <div className="flex flex-col flex-1">
                                            <p className="font-medium text-sm text-color-300 tracking-wider">
                                                {t('total products')}
                                            </p>
                                            <p className="mt-1 text-2xl font-bold text-gray-900 tracking-wide">
                                                {formatNumber(organization?.workspace_settings?.shops?.statistics?.product_count)}
                                            </p>
                                        </div>
                                        <Avatar
                                            size={40}
                                            className="flex flex-center bg-orange-100"
                                            icon={<FaBoxOpen size={20} className="text-orange-500"/>}
                                        />
                                    </div>

                                </div>
                            </div>
                            <button
                                style={{padding: '0.5rem'}}
                                className="mt-4 w-70 mx-auto sm:w-auto bg-indigo-500 hover:bg-indigo-600 font-medium text-white shadow-md rounded-lg hover:scale-xs transition"
                                onClick={() => setActiveTab('products')}>
                                {t("view products")}
                            </button>
                        </div>
                    );
                case 'products':
                    return (
                        <div className="flex flex-col">
                            <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                {t("manage products")}
                            </h3>
                            <div className="my-4 p-3 background-100 rounded-lg text-sm">
                                <span className="font-bold text-color-000">
                                    {`${t('note')}: `}
                                </span>
                                <span className="text-color-200 italic tracking-wider">
                                    {t("a product can belong to multiple categories at the same time")}
                                </span>
                            </div>
                            <ShopProducts shop_id={shop?.id}/>
                        </div>
                    );
                case 'catalogs':
                    return (
                        <div className="flex flex-col">
                            <div className="flex justify-between items-center mb-4">
                                <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                    {t("view catalogs")}
                                </h3>
                            </div>
                            <ShopCatalogs shop={shop}/>
                        </div>
                    );
                case 'settings':
                    return (
                        <div className="flex flex-col">
                            <h3 className="mb-4 font-bold text-base text-gray-700 tracking-wide uppercase">
                                {t("shop settings")}
                            </h3>
                            <div className="p-3 background border border-color-50 shadow-md rounded-lg">
                                <div className="text-color-300 tracking-wider">
                                    {t('shop settings description')}
                                </div>
                                <ul style={{paddingLeft: 20, listStyleType: 'disc'}} className="flex flex-col gap-1">
                                    <li className="text-color-300 tracking-wider">
                                        {t('update shop information')}
                                    </li>
                                    <li className="text-color-300 tracking-wider">
                                        {t('manage inventory and pricing')}
                                    </li>
                                    <li className="text-color-300 tracking-wider">
                                        {t('configure product categories & display settings')}
                                    </li>
                                </ul>
                            </div>

                            <div className="mt-3">
                                {!!shop?.id && (
                                    <ShopFormEdit
                                        owner_id={shop?.owner?.id}
                                        owner_type={getType(shop?.owner)}
                                        initialValues={shop}
                                        onCancel={onShopCancel}
                                        onSubmit={(values) => {
                                            editShopInfo(values, {id: shop?.id})
                                        }}
                                    />
                                )}
                            </div>

                        </div>
                    );
                case 'destroy':
                    return (
                        <div className="flex flex-col">
                            <div className="bg-white p-4 rounded-xl shadow-lg border-l-4 border-red-500">
                                <h3 className="mb-2 font-bold text-base text-gray-700 tracking-wide uppercase">
                                    {t('delete shop')}
                                </h3>
                                <p className="text-color-300 tracking-wider mb-4">
                                    {t('delete shop description')}
                                </p>
                                <div className="text-right">
                                    <button
                                        onClick={() => {
                                            showDeleteConfirmDialog({
                                                translate: t,
                                                title: 'delete shop',
                                                message: 'delete shop description',
                                                onOk: () => {
                                                    deleteShop({}, {id: shop?.id})
                                                },
                                            })
                                        }}
                                        className="px-6 py-2 bg-primary-600 hover:bg-primary-700 font-medium text-sm text-white shadow-md rounded-lg">
                                        {t("delete shop permanently")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                default:
                    return null;
            }
        },
        [activeTab, refreshShopKey, current_shop_id, shop?.id]);

    if (!!!current_shop_id) return null

    return (
        <div className="w-full min-h-screen">
            <div className="mb-3 flex flex-col flex-1">
                <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                    {t('shop management')}
                </h2>
                <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                <div className="mt-1 text-sm text-color-300 tracking-wider">
                    {t('shop management description')}
                </div>
            </div>

            <div className="mb-6 p-4 background shadow-lg rounded-b-xl stickyTop1 z-12">
                <button
                    onClick={() => {
                        onSelectShopContainerRoute({current_shop_id: '', current_product_id: ''})
                    }}
                    className="mb-2 flex items-center text-color-300 hover:text-color-100 tracking-wide cursor-pointer">
                    <BsArrowLeftCircle size={18} className="mr-2"/>
                    {t('back to shop list')}
                </button>
                <Link to={getLinkToDetail(shop)} className="text-primary-800 no-underline">
                    <h1 className="text-2xl font-bold tracking-wide">{shop.title}</h1>
                </Link>

            </div>

            <TabNavigation
                tabs={TABS_CONFIG}
                activeTab={activeTab}
                className="mt-6 border-color-300"
                style={{top: 'calc(3 * var(--header-height))', zIndex: 12}}
                onTabChange={(value) => {
                    onChangeSearchParams({"shop-detail-tab": value})
                    setActiveTab(value)
                }}/>

            <div className="p-3 md:p-6 background rounded-b-2xl shadow-lg">
                {renderTabContent}
            </div>
            {shopModal}
            <div className="h-16"/>
        </div>
    );
};


export default ShopDetail
